// Check if warranty-background section exists and set footer margin-top to 0
document.addEventListener('DOMContentLoaded', function() {
  const warrantyBackground = document.getElementById('shopify-section-warranty-background');
  const sectionFooter = document.getElementById('section-footer');
  
  if (warrantyBackground && sectionFooter) {
    sectionFooter.style.marginTop = '0';
  }
});

// Also check after page load in case elements are added dynamically
window.addEventListener('load', function() {
  const warrantyBackground = document.getElementById('shopify-section-warranty-background');
  const sectionFooter = document.getElementById('section-footer');
  
  if (warrantyBackground && sectionFooter) {
    sectionFooter.style.marginTop = '0';
  }
});
